// Curated master list of heavy-machinery manufacturer brands, supplied by
// the user -- used as ManufacturerBrand's autocomplete suggestions (the
// field itself stays free text, see FloatingLabelAutoComplete's own doc
// comment: nothing here ever blocks submit) and, on the search side, as the
// value space the "Marca" facet filter's counts are computed over. Global
// (not scoped per category like machineryBrandsSeed.ts's own brand/model
// suggestions) since the same manufacturer spans many machine types and the
// catalog itself isn't large enough yet to need per-category curation here.
export const MACHINERY_MANUFACTURER_BRANDS: string[] = [
  'Ammann',
  'Atlas Copco',
  'Ausa',
  'Avant Tecno',
  'Bell Equipment',
  'Bobcat',
  'Bomag',
  'Case Construction',
  'Caterpillar',
  'Claas',
  'Clark',
  'Combilift',
  'Cormidi',
  'CTE',
  'Develon',
  'Dieci',
  'Ditch Witch',
  'Dynapac',
  'Epiroc',
  'Eurocomach',
  'Faresin',
  'Fendt',
  'Gehl',
  'Genie',
  'Giant',
  'Hamm',
  'Haulotte',
  'Hiab',
  'Hidromek',
  'Hinowa',
  'Hitachi Construction Machinery',
  'Hyster',
  'Hyundai Construction Equipment',
  'JCB',
  'JLG',
  'John Deere',
  'Jungheinrich',
  'Kalmar',
  'Kato',
  'Kobelco',
  'Komatsu',
  'Komatsu Forest',
  'Kramer',
  'Kubota',
  'Liebherr',
  'Linde Material Handling',
  'LiuGong',
  'Magni',
  'Manitou',
  'Massey Ferguson',
  'Mecalac',
  'Menzi Muck',
  'Merlo',
  'Metso',
  'Multione',
  'Multitel Pagliero',
  'Mustang',
  'New Holland',
  'Niftylift',
  'Oil & Steel',
  'Palfinger',
  'Platform Basket',
  'Ponsse',
  'Potain',
  'Prinoth',
  'Putzmeister',
  'Ruthmann',
  'Same Deutz-Fahr',
  'Sampo Rosenlew',
  'Sandvik',
  'SANY',
  'Schwing',
  'Sennebogen',
  'Socage',
  'Still',
  'Tadano',
  'Takeuchi',
  'Terex',
  'Tigercat',
  'Toyota Material Handling',
  'Vermeer',
  'Volvo CE',
  'Vögele',
  'Wacker Neuson',
  'Wirtgen Group',
  'XCMG',
  'Yale',
  'Yanmar',
  'Yanmar Compact Equipment',
  'Zoomlion',
];
